export default __webpack_public_path__ + "static/media/image.black-hat-force-pvt-ltd.6e84613b.png";